/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
interface ServicesDetail {
  checkboxLabel: string;
  inputLabel: string;
  service: string;
  helperText: string;
  rate: number;
  selected: boolean;
}

enum CompanionServices {
  HOME_CARE_HOUR = 'HOME_CARE_HOUR',
  HOME_CARE_HALF_DAY = 'HOME_CARE_HALF_DAY',
  HOME_CARE_DAY = 'HOME_CARE_DAY',
  HOME_CARE_WEEK = 'HOME_CARE_WEEK',
  HOME_CARE_MONTH = 'HOME_CARE_MONTH',
  RESPITE_CARE_HOUR = 'RESPITE_CARE_HOUR',
  RESPITE_CARE_HALF_DAY = 'RESPITE_CARE_HALF_DAY',
  RESPITE_CARE_DAY = 'RESPITE_CARE_DAY',
  TRANSPORT_ONE_WAY = 'TRANSPORT_ONE_WAY',
}

enum PetServices {
  CHECK_IN = 'CHECK_IN',
  WALKING_HALF_HOUR = 'WALKING_HALF_HOUR',
  WALKING_HOUR = 'WALKING_HOUR',
  CARERS_HOME_DAYCARE = 'CARERS_HOME_DAYCARE',
  CARERS_HOME_OVERNIGHT = 'CARERS_HOME_OVERNIGHT',
  OWNERS_HOME_OVERNIGHT = 'OWNERS_HOME_OVERNIGHT',
  TRANSPORT = 'TRANSPORT',
  GROOMING = 'GROOMING',
  TRAINING = 'TRAINING',
}

type CompanionServicesOptions = {
  [key in CompanionServices]: ServicesDetail;
};

type PetServicesOptions = {
  [key in PetServices]: ServicesDetail;
};

const companionServicesOptions: CompanionServicesOptions = {
  [CompanionServices.HOME_CARE_HOUR]: {
    checkboxLabel: 'Home care- hourly rate',
    inputLabel: '$ Hourly rate',
    service: CompanionServices.HOME_CARE_HOUR,
    helperText: 'Enter an hourly rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.HOME_CARE_HALF_DAY]: {
    checkboxLabel: 'Home care- half-day rate',
    inputLabel: '$ Half day rate',
    service: CompanionServices.HOME_CARE_HALF_DAY,
    helperText: 'Enter a half day rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.HOME_CARE_DAY]: {
    checkboxLabel: 'Home care- full-day rate',
    inputLabel: '$ Full day rate',
    service: CompanionServices.HOME_CARE_DAY,
    helperText: 'Enter a full day rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.HOME_CARE_WEEK]: {
    checkboxLabel: 'Home care- weekly rate',
    inputLabel: '$ Weekly Rate',
    service: CompanionServices.HOME_CARE_WEEK,
    helperText: 'Enter an weekly rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.HOME_CARE_MONTH]: {
    checkboxLabel: 'Home care- monthly rate',
    inputLabel: '$ Monthly Rate',
    service: CompanionServices.HOME_CARE_MONTH,
    helperText: 'Enter an monthly rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.RESPITE_CARE_HOUR]: {
    checkboxLabel: 'Respite care- hourly rate',
    inputLabel: '$ Hourly Rate',
    service: CompanionServices.RESPITE_CARE_HOUR,
    helperText: 'Enter an hourly rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.RESPITE_CARE_HALF_DAY]: {
    checkboxLabel: 'Respite care- half-day rate',
    inputLabel: '$ Half day rate',
    service: CompanionServices.RESPITE_CARE_HALF_DAY,
    helperText: 'Enter a half day rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.RESPITE_CARE_DAY]: {
    checkboxLabel: 'Respite care- full-day rate',
    inputLabel: '$ Full day rate',
    service: CompanionServices.RESPITE_CARE_DAY,
    helperText: 'Enter a full day rate',
    rate: 0,
    selected: false,
  },
  [CompanionServices.TRANSPORT_ONE_WAY]: {
    checkboxLabel: 'Transportation- one-way rate',
    inputLabel: '$ Rate (one way)',
    service: CompanionServices.TRANSPORT_ONE_WAY,
    helperText: 'Enter a one way rate',
    rate: 0,
    selected: false,
  },
};

const petServicesOptions: PetServicesOptions = {
  [PetServices.CHECK_IN]: {
    checkboxLabel: 'Check-ins/visits- per visit',
    inputLabel: '$ per visit',
    service: PetServices.CHECK_IN,
    helperText: 'Enter a check-in and visit rate',
    rate: 0,
    selected: false,
  },
  [PetServices.WALKING_HALF_HOUR]: {
    checkboxLabel: 'Dog walking- 30-minute walk',
    inputLabel: '$ per 30-minute walk',
    service: PetServices.WALKING_HALF_HOUR,
    helperText: 'Enter a 30-minute dog walk rate',
    rate: 0,
    selected: false,
  },
  [PetServices.WALKING_HOUR]: {
    checkboxLabel: 'Dog walking- 60-minute walk',
    inputLabel: '$ per 60-minute walk',
    service: PetServices.WALKING_HOUR,
    helperText: 'Enter a 60-minute dog walk rate',
    rate: 0,
    selected: false,
  },
  [PetServices.CARERS_HOME_DAYCARE]: {
    checkboxLabel: 'Pet care in my home- per day',
    inputLabel: '$ per day',
    service: PetServices.CARERS_HOME_DAYCARE,
    helperText: 'Enter a per day pet care rate',
    rate: 0,
    selected: false,
  },
  [PetServices.CARERS_HOME_OVERNIGHT]: {
    checkboxLabel: 'Overnight pet care in my home- per night',
    inputLabel: '$ per night',
    service: PetServices.CARERS_HOME_OVERNIGHT,
    helperText: 'Enter a per night overnight pet care rate',
    rate: 0,
    selected: false,
  },
  [PetServices.OWNERS_HOME_OVERNIGHT]: {
    checkboxLabel: `Overnight pet care in owner's home- per night`,
    inputLabel: '$ per night',
    service: PetServices.OWNERS_HOME_OVERNIGHT,
    helperText: 'Enter a per night overnight pet care rate',
    rate: 0,
    selected: false,
  },
  [PetServices.TRANSPORT]: {
    checkboxLabel: 'Pick up and drop off- rate each way',
    inputLabel: '$ each way',
    service: PetServices.TRANSPORT,
    helperText: 'Enter a pick up and drop off rate',
    rate: 0,
    selected: false,
  },
  [PetServices.GROOMING]: {
    checkboxLabel: 'Bathing and grooming- per service',
    inputLabel: '$ per service',
    service: PetServices.GROOMING,
    helperText: 'Enter a bathing and grooming rate',
    rate: 0,
    selected: false,
  },
  [PetServices.TRAINING]: {
    checkboxLabel: 'Training- per hour',
    inputLabel: '$ per hour',
    service: PetServices.TRAINING,
    helperText: 'Enter a training hourly rate',
    rate: 0,
    selected: false,
  },
};

export {
  companionServicesOptions,
  CompanionServicesOptions,
  ServicesDetail,
  CompanionServices,
  petServicesOptions,
  PetServicesOptions,
};
